import api from './api';

export const getUserName = async (id) => {
    try {
        const response = await api.get(`/api/users/getUserName/${id}`);
        return response.data;
    } catch (error) {
        return [];
    }
};